export default __webpack_public_path__ + "static/media/document.86fd1153.svg";